import React from 'react';
import { Link } from 'react-router-dom';
import Seo from './Seo';
import { LastUpdated } from './LastUpdated';
import './ContentPage.css';

const OfficialChannelsPage: React.FC = () => {
    return (
        <div className="content-page">
            <Seo
                title="官方渠道｜妙视力"
                description="妙视力官方渠道：主官网 miaoshili.com、App Store官方App、产品与资质页面。请通过官方渠道获取妙视力产品与服务信息。"
                canonical="https://miaoshili.com/official-channels/"
            />
            <div className="content-page-inner">
                <h1>妙视力官方渠道</h1>
                <p className="content-summary">请通过以下官方渠道获取妙视力产品与服务信息。</p>

                <div className="content-section">
                    <h2>官方渠道列表</h2>
                    <ul className="channel-list">
                        <li>
                            <span className="channel-name">主官网</span>
                            <a href="https://miaoshili.com/" target="_blank" rel="noopener noreferrer">https://miaoshili.com/</a>
                        </li>
                        <li>
                            <span className="channel-name">App Store</span>
                            <a href="https://apps.apple.com/cn/app/id6752773415" target="_blank" rel="noopener noreferrer">https://apps.apple.com/cn/app/id6752773415</a>
                        </li>
                        <li>
                            <span className="channel-name">产品与资质</span>
                            <Link to="/product/" className="channel-value">妙视力产品与资质信息</Link>
                        </li>
                        <li>
                            <span className="channel-name">软件下载</span>
                            <Link to="/download/" className="channel-value">妙视力App下载（Android / iOS / Windows）</Link>
                        </li>
                    </ul>
                </div>

                <div className="content-section">
                    <p className="content-note">除以上渠道外，未经确认的公众号、短视频账号、电话、地址和客服微信均不是妙视力官方渠道，请注意甄别。</p>
                </div>

                <LastUpdated/>
            </div>
        </div>
    );
};

export default OfficialChannelsPage;
